module.exports = {
    "Gardens": {
        "Grass cutting and garden maintenance": {
            "url": "/grass_cutting_and_garden_maintenance",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251420/atcgardening/gardens/_grass_cutting.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251420/atcgardening/gardens/_grass_cutting.jpg",
            },
            "txt": "Grass cutting and garden maintenance",
        },
        "Bush hedge and shrub trimming and removal": {
            "url": "/bush_hedge_and_shrub_trimming_and_removal",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251420/atcgardening/gardens/_bush_hedge.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251420/atcgardening/gardens/_bush_hedge.jpg",
            },
            "txt": "Bush hedge and shrub trimming and removal",
        },
        "Tree and stump removal": {
            "url": "/tree_and_stump_removal",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1551567481/atcgardening/tree_and_stump_removal.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1551567481/atcgardening/tree_and_stump_removal.jpg",
            },
            "txt": "Tree and stump removal",
        },
        "Tree surgery": {
            "url": "/tree_surgery",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251658/atcgardening/gardens/_tree_surgery.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251658/atcgardening/gardens/_tree_surgery.jpg",
            },
            "txt": "Tree surgery",
        },
        "Artificial turf": {
            "url": "/artificial_turf",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251419/atcgardening/gardens/_artificial_turf.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251419/atcgardening/gardens/_artificial_turf.jpg",
            },
            "txt": "Artificial turf",
        }, 
        "Repairing and resurfacing of grass": {
            "url": "/repairing_and_resurfacing_of_grass",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251419/atcgardening/gardens/_repairing_and_resurfacing.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251419/atcgardening/gardens/_repairing_and_resurfacing.jpg",
            },
            "txt": "Repairing and resurfacing of grass",
        },
        "Planting of trees, bushes and flowers": {
            "url": "/planting_of_trees_bushes_and_flowers",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251421/atcgardening/gardens/_planting_of_trees.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251421/atcgardening/gardens/_planting_of_trees.jpg",
            },
            "txt": "Planting of trees, bushes and flowers",
        }, 
        "Garden material clearance": {
            "url": "/garden_material_clearance",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1551567478/atcgardening/garden_material_clearance.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1551567478/atcgardening/garden_material_clearance.jpg",
            },
            "txt": "Garden material clearance",
        },
        "Garden building removals": {
            "url": "/garden_building_removals",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1551567478/atcgardening/garden_building_removals.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1551567478/atcgardening/garden_building_removals.jpg",
            },
            "txt": "Garden building removals",
        },
    },
    "Fencing and Decking": {
        "Wooden fences": {
            "url": "/wooden_fences",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251279/atcgardening/fencing%20decking/_wooden_fences.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251279/atcgardening/fencing%20decking/_wooden_fences.jpg",
            },
            "txt": "Wooden fences",
        }, 
        "Metal fences": {
            "url": "/metal_fences",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1551569451/atcgardening/metal_fences.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1551569451/atcgardening/metal_fences.jpg",
            },
            "txt": "Metal fences",
        },
        "Panel fences": {
            "url": "/panel_fences",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251280/atcgardening/fencing%20decking/_panel_fences.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251280/atcgardening/fencing%20decking/_panel_fences.jpg",
            },
            "txt": "Panel fences",
        },
        "Gates": {
            "url": "/gates",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251280/atcgardening/fencing%20decking/_gates.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251280/atcgardening/fencing%20decking/_gates.jpg",
            },
            "txt": "",
        },
        "Decking": {
            "url": "/decking",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251286/atcgardening/fencing%20decking/_decking.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251286/atcgardening/fencing%20decking/_decking.jpg",
            },
            "txt": "",
        },
        "Wooden patio": {
            "url": "/wooden_patio",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251281/atcgardening/fencing%20decking/_wooden_patio.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251281/atcgardening/fencing%20decking/_wooden_patio.jpg",
            },
            "txt": "",
        },
        "Wooden seating area": {
            "url": "/wooden_seating_area",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552251281/atcgardening/fencing%20decking/_wooden_seating_area.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552251281/atcgardening/fencing%20decking/_wooden_seating_area.jpg",
            },
            "txt": "Wooden seating area",
        },
    },
    "Landscaping": {
        "Driveways": {
            "url": "/driveways",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250882/atcgardening/landscaping/_driveways.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250882/atcgardening/landscaping/_driveways.jpg",
            },
            "txt": "",
        },
        "Slabbing": {
            "url": "/slabbing",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250884/atcgardening/landscaping/_slabbing.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250884/atcgardening/landscaping/_slabbing.jpg",
            },
            "txt": "",
        },
        "Crazy paving": {
            "url": "/crazy_paving",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250883/atcgardening/landscaping/_crazy_paving.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250883/atcgardening/landscaping/_crazy_paving.jpg",
            },
            "txt": "",
        },
        "Paving": {
            "url": "/paving",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250884/atcgardening/landscaping/_paving.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250884/atcgardening/landscaping/_paving.jpg",
            },
            "txt": "",
        },
        "Chipping": {
            "url": "/chipping",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250881/atcgardening/landscaping/_chipping.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250881/atcgardening/landscaping/_chipping.jpg",
            },
            "txt": "",
        },
        "Kerbs": {
            "url": "/kerbs",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250881/atcgardening/landscaping/_kerbs.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250881/atcgardening/landscaping/_kerbs.jpg",
            },
            "txt": "",
        },
        "Drainage": {
            "url": "/drainage",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250884/atcgardening/landscaping/_drainage.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250884/atcgardening/landscaping/_drainage.jpg",
            },
            "txt": "",
        },
        "Land levelling": {
            "url": "/land_levelling",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250885/atcgardening/landscaping/_land_levelling.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250885/atcgardening/landscaping/_land_levelling.jpg",
            },
            "txt": "",
        },
        "Brick walls": {
            "url": "/brick_walls",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250888/atcgardening/landscaping/_brick_walls.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250888/atcgardening/landscaping/_brick_walls.jpg",
            },
            "txt": "",
        },
        "Concrete walls": {
            "url": "/concrete_walls",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1551570918/atcgardening/concrete_walls.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1551570918/atcgardening/concrete_walls.jpg",
            },
            "txt": "",
        },
        "Natural stone": {
            "url": "/natural_stone",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250884/atcgardening/landscaping/_natural_stone.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250884/atcgardening/landscaping/_natural_stone.jpg",
            },
            "txt": "",
        },
        "Coping": {
            "url": "/coping",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250880/atcgardening/landscaping/_cpoing.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250880/atcgardening/landscaping/_cpoing.jpg",
            },
            "txt": "",
        },
    },
    "Garden buildings": {
        "Custom sheds and man caves": {
            "url": "/custom_sheds_and_man_caves",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250681/atcgardening/garden%20buildings/_custom_sheds.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250681/atcgardening/garden%20buildings/_custom_sheds.jpg",
            },
            "txt": "",
        },
        "Hot tub building": {
            "url": "/hot_tub_building",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250680/atcgardening/garden%20buildings/_hot_tub.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250680/atcgardening/garden%20buildings/_hot_tub.jpg",
            },
            "txt": "",
        },
        "Pergola": {
            "url": "/pergola",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250680/atcgardening/garden%20buildings/_pergola.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250680/atcgardening/garden%20buildings/_pergola.jpg",
            },
            "txt": "",
        },
        "Summer house": {
            "url": "/summer_house",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250680/atcgardening/garden%20buildings/_summer_house.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250680/atcgardening/garden%20buildings/_summer_house.jpg",
            },
            "txt": "",
        },
        "Gazebo": {
            "url": "/gazebo",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250680/atcgardening/garden%20buildings/_gazebo.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250680/atcgardening/garden%20buildings/_gazebo.jpg",
            },
            "txt": "",
        },
        "Tool storage sheds": {
            "url": "/tool_storage_sheds",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250681/atcgardening/garden%20buildings/_tool_storage.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250681/atcgardening/garden%20buildings/_tool_storage.jpg",
            },
            "txt": "",
        },
        "Green house": {
            "url": "/green_house",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1551571837/atcgardening/green_house.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1551571837/atcgardening/green_house.jpg",
            },
            "txt": "",
        },
        "Wooden canopy": {
            "url": "/wooden_canopy",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250681/atcgardening/garden%20buildings/_wooden_canopy.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250681/atcgardening/garden%20buildings/_wooden_canopy.jpg",
            },
            "txt": "",
        },
    },
    "Garages": {
        "Wooden garages": {
            "url": "/wooden_garages",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552249877/atcgardening/garages/_garage1.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552249877/atcgardening/garages/_garage1.jpg",
            },
            "txt": "",
        },
        "Brick garages": {
            "url": "/brick_garages",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552249877/atcgardening/garages/_garage2.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552249877/atcgardening/garages/_garage2.jpg",
            },
            "txt": "",
        },
    },
    "Kids Zone": {
        "Custom play parks": {
           "url": "/custom_play_parks",
        "pic": {
            full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250485/atcgardening/kids%20zone/_custom_play_parks.jpg",
            mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250485/atcgardening/kids%20zone/_custom_play_parks.jpg",
        },
        "txt": "Custom play parks",
      },
        "Swings": {
            "url": "/swings",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250485/atcgardening/kids%20zone/_swings.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250485/atcgardening/kids%20zone/_swings.jpg",
            },
            "txt": "",
        },
        "Sandpits": {
            "url": "/sandpits",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250485/atcgardening/kids%20zone/_sandpits.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250485/atcgardening/kids%20zone/_sandpits.jpg",
            },
            "txt": "",
        },
        "Tree houses": {
            "url": "/tree_houses",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250487/atcgardening/kids%20zone/_tree_house.png",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250487/atcgardening/kids%20zone/_tree_house.png",
            },
            "txt": "",
        },
        "Play houses": {
            "url": "/play_houses",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250485/atcgardening/kids%20zone/_play_house.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250485/atcgardening/kids%20zone/_play_house.jpg",
            },
            "txt": "",
        },
    },
    "Pet Zone": {
        "Dog houses": {
            "url": "/dog_houses",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250218/atcgardening/pet_zone/_dog_house.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250218/atcgardening/pet_zone/_dog_house.jpg",
            },
            "txt": "",
        },
        "Dog kennels": {
            "url": "/dog_kennels",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250218/atcgardening/pet_zone/_dog_kennel.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250218/atcgardening/pet_zone/_dog_kennel.jpg",
            },
            "txt": "",
        },
        "Dog runs": {
            "url": "/dog_runs",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552246663/atcgardening/home/pet_zone_home_picture.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552246663/atcgardening/home/pet_zone_home_picture.jpg",
            },
            "txt": "",
        },
        "Rabbit hutches": {
            "url": "/rabbit_hutches",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250218/atcgardening/pet_zone/_rabbit_hutch.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250218/atcgardening/pet_zone/_rabbit_hutch.jpg",
            },
            "txt": "",
        }, 
        "Rabbit runs": {
            "url": "/rabbit_runs",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250218/atcgardening/pet_zone/_rabbit_run.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250218/atcgardening/pet_zone/_rabbit_run.jpg",
            },
            "txt": "",
        },
        "Chicken coup": {
            "url": "/chicken_coup",
            "pic": {
                full: "https://res.cloudinary.com/threesix/image/upload/h_600/v1552250217/atcgardening/pet_zone/_chicken_coup.jpg",
                mobile: "https://res.cloudinary.com/threesix/image/upload/h_300/v1552250217/atcgardening/pet_zone/_chicken_coup.jpg",
            },
            "txt": "",
        },
    },
}


// WEBPACK FOOTER //
// ./assets/categories.js